var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinkAgente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.641,
    height: 60.408,
    viewBox: "0 0 54.641 60.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_285",
    "data-name": "Rettangolo 285",
    width: 54.641,
    height: 60.408,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_345",
    "data-name": "Raggruppa 345",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1089",
    "data-name": "Tracciato 1089",
    d: "M56.462,32.052A15.455,15.455,0,1,1,41.006,16.6,15.455,15.455,0,0,1,56.462,32.052",
    transform: "translate(-13.678 -8.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1090",
    "data-name": "Tracciato 1090",
    d: "M39.937,47.367A16.385,16.385,0,1,1,56.321,30.983,16.4,16.4,0,0,1,39.937,47.367m0-30.911A14.526,14.526,0,1,0,54.462,30.983,14.542,14.542,0,0,0,39.937,16.457",
    transform: "translate(-12.608 -7.815)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1091",
    "data-name": "Tracciato 1091",
    d: "M55.484,106.082A11.185,11.185,0,0,0,44.3,94.9H22.884A11.185,11.185,0,0,0,11.7,106.082v4.2",
    transform: "translate(-6.263 -50.8)",
    fill: "#dd2027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1092",
    "data-name": "Tracciato 1092",
    d: "M10.627,110.138a.93.93,0,0,1-.929-.929v-4.2A12.128,12.128,0,0,1,21.813,92.9H43.227a12.129,12.129,0,0,1,12.115,12.115.929.929,0,0,1-1.859,0A10.268,10.268,0,0,0,43.227,94.756H21.813a10.268,10.268,0,0,0-10.256,10.256v4.2a.93.93,0,0,1-.929.929",
    transform: "translate(-5.192 -49.73)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1093",
    "data-name": "Tracciato 1093",
    d: "M46.246,17.481A15.458,15.458,0,0,0,25.713,30.533,14.279,14.279,0,0,0,46.244,17.7s0-.069,0-.217",
    transform: "translate(-13.765 -8.885)",
    fill: "#dd2027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1094",
    "data-name": "Tracciato 1094",
    d: "M30.9,31.833A15.063,15.063,0,0,1,24.235,30.3a.929.929,0,0,1-.517-.925A16.39,16.39,0,0,1,45.487,15.534a.93.93,0,0,1,.619.876c0,.165,0,.242,0,.242A15.218,15.218,0,0,1,30.9,31.833M25.646,28.9A13.219,13.219,0,0,0,30.9,29.975,13.363,13.363,0,0,0,44.237,17.08,14.53,14.53,0,0,0,25.646,28.9",
    transform: "translate(-12.694 -7.815)",
    fill: "#dd2027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1095",
    "data-name": "Tracciato 1095",
    d: "M80.185,32.673a15.457,15.457,0,0,0-9.713-13.708H69.9A14.28,14.28,0,0,0,80.185,32.673",
    transform: "translate(-37.418 -10.152)",
    fill: "#dd2027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1096",
    "data-name": "Tracciato 1096",
    d: "M79.114,32.53a.931.931,0,0,1-.259-.037A15.278,15.278,0,0,1,67.9,17.893a.929.929,0,0,1,.929-.929H69.4a.928.928,0,0,1,.344.066,16.4,16.4,0,0,1,10.3,14.532.928.928,0,0,1-.928.967m-9.3-13.448a13.436,13.436,0,0,0,8.251,11.169A14.545,14.545,0,0,0,69.81,19.082",
    transform: "translate(-36.347 -9.081)",
    fill: "#dd2027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1097",
    "data-name": "Tracciato 1097",
    d: "M54.6,22.386a.93.93,0,0,1-.929-.929,19.6,19.6,0,0,0-39.2,0,.929.929,0,1,1-1.859,0,21.457,21.457,0,0,1,42.914,0,.93.93,0,0,1-.929.929",
    transform: "translate(-6.755)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1098",
    "data-name": "Tracciato 1098",
    d: "M6.793,53.167H5.955a5.955,5.955,0,1,1,0-11.91h.837a.93.93,0,0,1,.929.929V52.238a.93.93,0,0,1-.929.929M5.863,43.117a4.1,4.1,0,0,0,0,8.191Z",
    transform: "translate(0 -22.086)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1099",
    "data-name": "Tracciato 1099",
    d: "M102.737,53.167H101.9a.93.93,0,0,1-.929-.929V42.186a.93.93,0,0,1,.929-.929h.838a5.955,5.955,0,0,1,0,11.91m.092-10.051v8.191a4.1,4.1,0,0,0,0-8.191",
    transform: "translate(-54.051 -22.086)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1100",
    "data-name": "Tracciato 1100",
    d: "M32.535,58.334H14.373a1.758,1.758,0,0,1-1.756-1.756V45.455a.929.929,0,0,1,1.859,0v11.02H32.535a.929.929,0,0,1,0,1.859",
    transform: "translate(-6.754 -23.836)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1101",
    "data-name": "Tracciato 1101",
    d: "M55.958,71.865a2.477,2.477,0,1,1,2.476-2.477,2.479,2.479,0,0,1-2.476,2.477m0-3.095a.618.618,0,1,0,.618.618.619.619,0,0,0-.618-.618",
    transform: "translate(-28.629 -35.819)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1102",
    "data-name": "Tracciato 1102",
    d: "M55.259,31.66a14.264,14.264,0,0,1-1.684-.407A14.767,14.767,0,0,1,43.284,17v-.455a16.163,16.163,0,0,0-1.733-.58v1.016c0,.007,0,.013,0,.019,0,.03,0,.059,0,.089v.031c0,.007,0,.013,0,.02v.217A13.424,13.424,0,0,1,28.138,30.77a13.277,13.277,0,0,1-5.874-1.353c-.363-.177-.717-.374-1.063-.584a13.476,13.476,0,0,1-1.244-.849A.867.867,0,0,0,18.9,29.357,15.2,15.2,0,0,0,20.975,30.7c.175.094.349.187.527.274a15.005,15.005,0,0,0,6.636,1.529A15.173,15.173,0,0,0,42.42,22.4,16.268,16.268,0,0,0,53.528,33.04c.469.128.944.243,1.43.329a.886.886,0,0,0,.151.013.868.868,0,0,0,.149-1.722",
    transform: "translate(-9.935 -8.549)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1103",
    "data-name": "Tracciato 1103",
    d: "M54.842,33.265a1.086,1.086,0,0,1-.192-.017c-.441-.078-.9-.184-1.45-.333A16.452,16.452,0,0,1,42.146,22.729a15.413,15.413,0,0,1-14.275,9.659,15.235,15.235,0,0,1-6.737-1.553c-.181-.088-.358-.183-.535-.278a15.451,15.451,0,0,1-2.111-1.365,1.1,1.1,0,1,1,1.344-1.741,13.254,13.254,0,0,0,1.223.835c.362.22.7.407,1.045.573a13.045,13.045,0,0,0,5.772,1.33A13.192,13.192,0,0,0,41.048,17.012l.006-.266,0-.109,0-.029,0-1.291.293.08a16.348,16.348,0,0,1,1.757.588l.147.059v.613A14.461,14.461,0,0,0,53.375,30.682a14.045,14.045,0,0,0,1.657.4,1.1,1.1,0,0,1-.19,2.183M42.16,21.335l.214.643A16.014,16.014,0,0,0,53.322,32.467c.535.145.982.248,1.409.323a.635.635,0,1,0,.22-1.251,14.55,14.55,0,0,1-1.711-.413A14.923,14.923,0,0,1,42.785,16.655v-.3c-.42-.162-.844-.307-1.268-.431l0,1.086A13.657,13.657,0,0,1,27.871,30.654,13.508,13.508,0,0,1,21.9,29.276c-.354-.172-.708-.367-1.082-.593a13.845,13.845,0,0,1-1.266-.864.623.623,0,0,0-.469-.127.63.63,0,0,0-.421.242.636.636,0,0,0,.115.891,15.007,15.007,0,0,0,2.047,1.323c.172.092.344.184.52.27a14.779,14.779,0,0,0,6.533,1.505,14.946,14.946,0,0,0,14.063-9.95Z",
    transform: "translate(-9.668 -8.199)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinkAgente);
export default __webpack_public_path__ + "static/media/clink_agente.4567b25bc0843a939fa7127cd8f6510f.svg";
export { ForwardRef as ReactComponent };